



































import Vue from "vue";
import { AccessLevel } from "@/common/enums/AccessLevel";

export default Vue.extend({
  name: "UAUpdateAccess",
  props: {
    userName: {
      type: String,
      required: true,
    },
    currentAccessLevel: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      selectedAccessLevel: this.currentAccessLevel,
      isOpen: false,
      AccessLevel,
    };
  },
  methods: {
    updateAccessLevel(selected: string): void {
      this.$emit("select", selected);
      this.isOpen = false;
    },
    close(): void {
      this.selectedAccessLevel = this.currentAccessLevel;
      this.isOpen = false;
    },
  },
});
